/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'

import {Loading} from '../../../../components/Loading/Loading'
import {i18n} from '../../../../translate/i18n'
import {CardFreight} from '../../../../components/CardFreight'
import DeliveryImg from '../../../../assets/freights/delivery.jpeg'
import FrenetImg from '../../../../assets/freights/frenet.jpeg'
import {GET, POST, PUT} from '../../../../services/api'
import {IntegrationType} from '../../../../context/pluginSpaceContext'

type AppconfigResponseType = {
  id: number
  name: string
  locationId: number
  info: string
  type: string
  background: null | string
  banner: null | string
  img: null | string
  icon: null | string
  content: {
    qtdProductsPagination: number
    useLogoMenu: boolean
    pdv: any
    webappcolor: {
      backgroundbuttonhome: string
      backgroundcart: string
      backgroundfooter: string
      backgroundheader: string
      backgroundmenu: string
      backgroundstatus: string
      backgroundstatusactive: string
      backgroundtitlebar: string
      backgroundwebapp: string
      fontbutton: string
      fontbuttonhome: string
      fontcart: string
      fontcategory: string
      fontheader: string
      fontinfocart: string
      fontmenu: string
      fontstatus: string
      fonttitlebar: string
      highlightfooter: string
      iconsfooter: string
      iconsheader: string
      icontitlebar: string
      webappbutton: string
    }
  }
}

// type PluginconfigResponseType = {
//   id: number
//   name: string
//   plugintypeId: number
//   plugintemplateId: number
//   content: any
// }

type ContentFrenetType = {
  able: boolean
  token: string
  declaredValue: boolean
}

type LocationType = {
  id: number
  code: string
  name: string
}

const TaxaEntregaEscolhaContent: FC = () => {
  const [loading, setLoading] = useState(false)
  const [appConfig, setAppConfig] = useState<AppconfigResponseType | null>(null)
  const [appConfigWholeSale, setAppConfigWholeSale] = useState<AppconfigResponseType | null>(null)
  const [contentFrenet, setContentFrenet] = useState<ContentFrenetType | null>(null)
  const [idFrenet, setIdFrenet] = useState(0)
  const [deliveryLocationName, setDeliveryLocationName] = useState('')

  const activeItem = async (type: string) => {
    if (type === 'frenet') {
      if (contentFrenet && idFrenet) {
        const newContentFrenet = {...contentFrenet}
        newContentFrenet.able = !contentFrenet.able
        setContentFrenet(newContentFrenet)
        await PUT(`/pluginconfig/${idFrenet}`, {
          content: newContentFrenet,
        })
      } else {
        const newContentFrenet = {
          able: true,
          declaredValue: false,
          token: '',
        }
        setContentFrenet(newContentFrenet)
        const res = await POST(`/pluginconfig`, {
          plugintypeId: 1,
          plugintemplateId: 119,
          name: 'Frenet',
          content: newContentFrenet,
        })
        if (res && res.dados && res.dados.id) setIdFrenet(res.dados.id)
      }
    } else if (type === 'delivery' && appConfig) {
      const newAppConfig = {...appConfig}
      newAppConfig.content.pdv.internal_delivery = !appConfig.content.pdv.internal_delivery
        ? true
        : false
      setAppConfig(newAppConfig)
      await PUT(`/appconfig/${appConfig.id}`, {
        content: newAppConfig.content,
      })
      if (appConfigWholeSale && appConfig) {
        const newAppConfigWholeSale = {...appConfigWholeSale}
        newAppConfigWholeSale.content.pdv.internal_delivery = !appConfig.content.pdv
          .internal_delivery
          ? true
          : false
        setAppConfigWholeSale(newAppConfigWholeSale)
        await PUT(`/appconfig/${appConfig.id}`, {
          content: newAppConfig.content,
        })
      }
    }
  }

  const getConfig = async () => {
    try {
      const appRes = await GET(`/appconfig`)
      const pluginconfigRes = await GET(`/pluginconfig`)
      const locationRes = await GET(`/location`)
      const appConfigFinded = appRes.data.find((app: AppconfigResponseType) => app.type === 'qr')
      const appConfigWholeSaleFinded = appRes.data.find(
        (app: AppconfigResponseType) => app.type === 'qr_whole_sale'
      )

      if (appConfigWholeSaleFinded) {
        setAppConfigWholeSale(appConfigWholeSaleFinded)
      }

      const pluginconfigFinded = pluginconfigRes.data.find(
        (pgConfig: IntegrationType) => pgConfig.plugintemplateId === 119
      )
      const locationDelivery = locationRes.data.find(
        (location: LocationType) => location.code === 'delivery'
      )
      setAppConfig(appConfigFinded ? appConfigFinded : null)
      setDeliveryLocationName(locationDelivery ? locationDelivery.name : '')
      setContentFrenet(
        pluginconfigFinded && pluginconfigFinded.content ? pluginconfigFinded.content : null
      )
      setIdFrenet(pluginconfigFinded && pluginconfigFinded.id ? pluginconfigFinded.id : 0)
    } catch (e) {
      console.log(e)
    }
  }

  const init = async () => {
    setLoading(true)
    await getConfig()
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`freight.title`)}</span>
              </h3>
            </div>
            <div className='card-body'>
              <div className='d-flex flex-row flex-wrap gap-7'>
                {deliveryLocationName && (
                  <CardFreight
                    name={deliveryLocationName}
                    description={
                      <>
                        <p>{i18n.t(`freight.delivery_text`)}</p>
                        <ul>
                          <li>
                            <p>{i18n.t(`freight.map`)}</p>
                          </li>
                          <li>
                            <p>{i18n.t(`freight.range`)}</p>
                          </li>
                          <li>
                            <p>{i18n.t(`freight.cep`)}</p>
                          </li>
                        </ul>
                      </>
                    }
                    activeItem={activeItem}
                    able={
                      appConfig &&
                      appConfig.content &&
                      appConfig.content.pdv &&
                      appConfig.content.pdv.internal_delivery
                    }
                    type='delivery'
                    image={DeliveryImg}
                    key={1}
                    link='/configuracoes/taxa-entrega/interno'
                  />
                )}
                <CardFreight
                  name={i18n.t(`freight.frenet`)}
                  description={
                    <>
                      <p>
                        {i18n.t(`freight.frenet_text`)}
                        <br />
                        {i18n.t(`freight.frenet_text_2`)}
                      </p>
                      <a target='_blank' rel='noreferrer' href='https://www.frenet.com.br/'>
                        {i18n.t(`freight.site`)}
                        <svg
                          className='m-2'
                          width='12'
                          height='13'
                          viewBox='0 0 12 13'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M7.125 1.0625C7.125 0.757812 7.35938 0.5 7.6875 0.5H11.4141C11.7422 0.5 11.9766 0.757812 11.9766 1.0625V4.8125C11.9766 5.14062 11.7422 5.375 11.4141 5.375C11.1094 5.375 10.8516 5.14062 10.8516 4.8125V2.42188L5.625 7.64844C5.41406 7.88281 5.0625 7.88281 4.85156 7.64844C4.61719 7.4375 4.61719 7.08594 4.85156 6.85156L10.0781 1.625H7.6875C7.35938 1.625 7.125 1.39062 7.125 1.0625ZM1.6875 1.25H4.6875C4.99219 1.25 5.25 1.50781 5.25 1.8125C5.25 2.14062 4.99219 2.375 4.6875 2.375H1.6875C1.35938 2.375 1.125 2.63281 1.125 2.9375V10.8125C1.125 11.1406 1.35938 11.375 1.6875 11.375H9.5625C9.86719 11.375 10.125 11.1406 10.125 10.8125V7.8125C10.125 7.50781 10.3594 7.25 10.6875 7.25C10.9922 7.25 11.25 7.50781 11.25 7.8125V10.8125C11.25 11.75 10.4766 12.5 9.5625 12.5H1.6875C0.75 12.5 0 11.75 0 10.8125V2.9375C0 2.02344 0.75 1.25 1.6875 1.25Z'
                            fill='#3C9EE6'
                          />
                        </svg>
                      </a>
                    </>
                  }
                  activeItem={activeItem}
                  able={contentFrenet && contentFrenet.able ? true : false}
                  type='frenet'
                  image={FrenetImg}
                  key={2}
                  link='/configuracoes/taxa-entrega/frenet'
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const TaxaEntregaEscolha: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`delivery_fee.delivery_fee`),
            path: 'configuracoes/taxa-entrega/raio',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`delivery_fee.delivery_fee`)}
      </PageTitle>
      <TaxaEntregaEscolhaContent />
    </>
  )
}

export {TaxaEntregaEscolha}
